var Backbone, SupportV2OptimizedContactChannelsModel, V2OptimizedContactChannelsTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

V2OptimizedContactChannelsTemplate = require('../../v2_optimized_contact_channels.html.mustache');

SupportV2OptimizedContactChannelsModel = (function(superClass) {
  extend(SupportV2OptimizedContactChannelsModel, superClass);

  function SupportV2OptimizedContactChannelsModel() {
    return SupportV2OptimizedContactChannelsModel.__super__.constructor.apply(this, arguments);
  }

  SupportV2OptimizedContactChannelsModel.prototype.initialize = function() {
    return this.template = V2OptimizedContactChannelsTemplate;
  };

  SupportV2OptimizedContactChannelsModel.prototype.toHash = function() {
    this.setOrderInfo();
    this.setIssueInfo();
    return this.toJSON();
  };

  SupportV2OptimizedContactChannelsModel.prototype.setOrderInfo = function() {
    var order, ref, ref1, title;
    order = Groupon.Support.currentOrder;
    if (order) {
      title = ((ref = order.deal) != null ? ref.title : void 0) || ((ref1 = order.merchant) != null ? ref1.name : void 0);
      if (title) {
        return this.set('orderMsg', I18n.translate('js.modules.support.issue_about_this_order', {
          dealTitle: title
        }));
      }
    }
  };

  SupportV2OptimizedContactChannelsModel.prototype.setIssueInfo = function() {
    var issue, ref;
    issue = Groupon.Support.ContentModel.getSearchInputIssue() || ((ref = Groupon.Support.ContentModel.getSubCategory()) != null ? ref.text : void 0);
    if (issue) {
      return this.set('issueMsg', I18n.translate('js.modules.support.saw_you_have_issue', {
        issue: issue
      }));
    }
  };

  SupportV2OptimizedContactChannelsModel.prototype.hidePreferencedContactChannel = function() {
    var optimizedContactChannels;
    optimizedContactChannels = [this.optimizephoneBtnElem(), this.optimizeEmailBtnElem(), this.optimizedLiveChatContainer()];
    return removePreferredContactClass(optimizedContactChannels);
  };

  SupportV2OptimizedContactChannelsModel.prototype.showPreferencedContactChannel = function(type) {
    var preferredContactElem;
    switch (type) {
      case "chat":
        preferredContactElem = this.optimizedLiveChatContainer();
        break;
      case "email":
        preferredContactElem = this.optimizeEmailBtnElem();
        break;
      case "phone":
        preferredContactElem = this.optimizephoneBtnElem();
    }
    return addPreferredContactClass(preferredContactElem);
  };

  SupportV2OptimizedContactChannelsModel.prototype.optimizedLiveChatVisible = function() {
    return window.liveChatVisible($(".live-chat-container.optimized-contact-channel a img"));
  };

  SupportV2OptimizedContactChannelsModel.prototype.setOptimizedLiveChatDisplayCallBack = function(liveChatDisplayCallback) {
    return window.setLiveChatDisplayCallBack($(".live-chat-container.optimized-contact-channel a img"), liveChatDisplayCallback);
  };

  SupportV2OptimizedContactChannelsModel.prototype.optimizephoneBtnElem = function() {
    return $('.optimized-phone-btn');
  };

  SupportV2OptimizedContactChannelsModel.prototype.optimizeEmailBtnElem = function() {
    return $('.optimized-email-us');
  };

  SupportV2OptimizedContactChannelsModel.prototype.optimizedLiveChatContainer = function() {
    return $('.optimized-live-chat-container');
  };

  SupportV2OptimizedContactChannelsModel.prototype.emailRecommendationTextElement = function() {
    return $('');
  };

  SupportV2OptimizedContactChannelsModel.prototype.phoneRecommendationTextElement = function() {
    return $('');
  };

  return SupportV2OptimizedContactChannelsModel;

})(Backbone.Model);

module.exports = SupportV2OptimizedContactChannelsModel;

//# sourceMappingURL=data:application/json;base64,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
